<template>
    <div class="bg-white px-3 index">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item label="类型">
                        <el-select v-model="lb_value" placeholder="请选择" clearable size="small" filterable>
                            <el-option v-for="item in  lb_options" :key="item.id" :label="item.text" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="医生">
                        <el-select v-model="doc_value" placeholder="请选择" clearable size="small" filterable>
                            <el-option v-for="item in  doc_options" :key="item.id" :label="item.nickname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="用户名">
                        <el-input v-model="user_name" size="small" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>

            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="user_id" label="ID"></el-table-column>
                <el-table-column prop="nickname" label="昵称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="头像">
                    <template slot-scope="{row}">
                        <div class="u-f u-wrap">
                            <el-image style="width: 50px; height: 50px" :src="row.headimgurl"
                                :preview-src-list="[row.headimgurl]">
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="type_id" label="是否关注" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.subscribe==1">已关注</span>
                        <span v-else-if="scope.row.subscribe==0">未关注</span>
                    </template>
                </el-table-column>
                <el-table-column prop="scene" label="场景" show-overflow-tooltip></el-table-column>
                <el-table-column prop="subscribe_time" label="关注时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="gzhStr" label="公众号"></el-table-column>
                <el-table-column prop="gzhStr" label="轨迹">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="openlookgj(row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!--  -->
        <el-dialog title="轨迹查看" :visible.sync="gjdialogVisible" top="50px" width="60%" class="dialogs">
            <el-divider></el-divider>
            <Gj ref="gjlist" />
            <el-divider></el-divider>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="contentvotedetail=false" size="small">确定</el-button>
            </span> -->
        </el-dialog>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import tinymce from '@/components/common/tinymce.vue';
    import Gj from "./gj.vue";
    export default {
        components: {
            tinymce,
            Gj
        },
        data() {
            return {
                lb_value: '',
                lb_options: [{
                        id: 1,
                        text: '已关注'
                    },
                    {
                        id: 0,
                        text: '未关注'
                    },

                ],
                user_name:'',

                ht_options: [],
                ht_options2: [],
                ry_options: [],
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 10,
                height: null,
                // 
                eid: '0',
                dialogVisible: false,
                detaildialogVisible: false,
                gjdialogVisible: false,
                subloading: false,
                dataId: '',
                listItem: [],

                ruleForm: {
                    lb_value: '',
                    keyword: '',
                    lb_dstime: '',
                    lb_put: 1,
                    lb_mapList: [],
                    kj_value: '',

                    ht_value: '',
                    ht_value2: '',
                    ry_value: '',
                    textarea: '',
                },
                getruleForm: {
                    rytext: '',
                    pltext: '',
                    ht_value2: '',
                    textarea: '',
                    kj_value: '',
                    lb_value: '',
                    images: '',
                    ry_value2: '',


                },
                zan: false,
                mapListed: [],
                rule: {
                    lb_value: [{
                        required: true,
                        message: '请选择类别',
                        trigger: 'blur'
                    }],
                    kj_value: [{
                        required: true,
                        message: '请选择谁可见',
                        trigger: 'blur'
                    }],

                    textarea: [{
                        required: true,
                        message: '请填写内容',
                        trigger: 'blur'
                    }],
                    ry_value: [{
                        required: true,
                        message: '请选择人员',
                        trigger: 'blur'
                    }],
                    ry_value2: [{
                        required: true,
                        message: '请选择人员',
                        trigger: 'blur'
                    }],
                    ht_value: [{
                        required: true,
                        message: '请选择话题类型',
                        trigger: 'blur'
                    }],
                    ht_value2: [{
                        required: true,
                        message: '请选择话题列表',
                        trigger: 'blur'
                    }],
                    keyword: [{
                        required: true,
                        message: '请填写关键词',
                        trigger: 'blur'
                    }],
                    lb_put: [{
                        required: true,
                        message: '请选择发布设置',
                        trigger: 'blur'
                    }],
                },
                // 
                dialog_prev: false,
                urls: '',
                topic_child_options: [],
                date: xaoi.date,
                doc_options: [],
                doc_value: ''


            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            this.getdoc()
            that.getHeight()
            this.begin()
        },
        methods: {
            getdoc() {
                axios
                    .post("/admin/doctorAssistantList", {
                        type: 9
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.doc_options = response.data.data
                    })
                    .catch(error => {})
            },
            beforeUpload() {
                if (!this.ruleForm.ry_value) {
                    this.$message({
                        message: '请先选择人员哦',
                        type: 'warning'
                    });
                    return false
                }
            },
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 220 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 220 + 'px'
                }
            },

            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 10
                that.search()
            },
            async search() {
                let that = this
                that.tableData = []
                that.loading = true
                let params = {
                    page_count: this.pagesize,
                    page: this.currentPage,
                    is_subscribe: that.lb_value,
                    user_id: this.doc_value,
                    name:this.user_name
                }
                this.axios.post('/admin/wssadmin/wechat/index', params, {
                    token: true
                }).then(res => {
                    that.loading = false
                    if (res.data.code == 200) {
                        that.tableData = res.data.data.list
                        that.count = res.data.data.count
                    }
                })
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = ''
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm.lb_value = ''
                that.ruleForm.textarea = ''
                that.ruleForm.lb_mapList = []
                that.ruleForm.ry_value = ''
                that.mapListed = []
            },
            // 鼠标单击的事件
            onClick(e, editor) {},
            async submit(formName) {
                let that = this
                that.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        let arr1 = []
                        let obj = {}
                        if (that.mapListed.length > 0) {
                            that.mapListed.forEach(ele => {
                                obj = {
                                    url: ele.url
                                }
                                arr1.push(obj)
                            })
                        }
                        that.subloading = true
                        let params = {
                            id: this.eid,
                            file: JSON.stringify(arr1),
                            content: that.ruleForm.textarea,
                            type_id: that.ruleForm.lb_value,
                            ry_value: that.ruleForm.ry_value
                        }
                        let res = await this.ajax('acadexchange/index/add', params)
                        if (res.code == 200) {
                            this.$message({
                                type: 'success',
                                message: '成功!'
                            });
                            that.dialogVisible = false
                            this.search()
                        } else {
                            that.$message.error(res.data.msg);
                        }
                        that.subloading = false
                    } else {
                        this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            //编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                this.ruleForm.lb_mapList = []
                this.mapListed = []
                this.mapListed = row.files
                this.ruleForm.lb_mapList = row.files
                that.dialogVisible = true
                that.eid = row.id
                this.ruleForm.ry_value = row.create_user
                that.ruleForm.lb_value = row.type_id
                that.ruleForm.textarea = row.body

            },
            // 删除
            async handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    let res = await this.ajax('acadexchange/index/del', {
                        id: row.id,
                        ry_value: row.create_user,
                    })
                    if (res.code == '200') {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        that.search()
                    } else {
                        that.$message.error(res.data.msg);
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            gettimes() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                let hour = nowDate.getHours(); //获取系统时，
                let min = nowDate.getMinutes(); //分
                let sec = nowDate.getSeconds(); //秒
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                hour = hour > 9 ? hour : '0' + hour
                min = min > 9 ? min : '0' + min
                sec = sec > 9 ? sec : '0' + sec
                return `${year}-${month}-${day} ${hour}:${min}`;
            },
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
            openlookgj(row) {
                this.gjdialogVisible = true
                this.$nextTick(() => {

                    this.$refs.gjlist.currentPage = 1
                    this.$refs.gjlist.formData.user_value = row.user_id
                    this.$refs.gjlist.getlist(row.user_id)
                })
            }

        },

    };
</script>


<style>
    .con_de {
        /* border: 1px solid red; */
        /* width: 200px; */
        width: 100%;
        max-height: 200px;
        overflow-y: scroll;
        line-height: 18px;
        position: relative;
        top: 7px;
        background-color: rgb(247, 245, 245);
        border-radius: 5px;
        padding: 5px;
    }

    .imgs {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 5px;
    }

    .lefts {
        max-height: 500px;
        overflow: auto;
    }

    .delt {
        color: red;
        font-size: 20px;
    }

    .blues {
        color: #409eff;
    }

    .concon {
        background: #f5f5f5;
        padding: 10px;
        border-radius: 10px;
    }

    .zanbtn {
        width: 30px;
        display: flex;
        /* border: 1px solid red; */
        cursor: pointer;
    }

    .zanbtn img {
        width: 100%;
        display: block;
    }

    .singleimg {
        width: 100px;
        width: 100px;
    }

    .singleimg img {
        width: 100%;
        height: 100%;
        display: block;
    }

    .imgbox {
        display: flex;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .tablimg {
        margin: 2px 5px;
    }
</style>